import React, {useContext, useEffect, useState} from 'react';
import { Field } from 'react-final-form';
import MuiButton from "@material-ui/core/Button";

import RadioButton from './RadioBig';
import Grid from "@material-ui/core/Grid";
import Select from "./Select";
import TextInput from "./TextInput";
import styled from "styled-components";
import SelectCard from "./SelectCard";
import {getCookieValue} from "../utils/getCookieValue";

import { Trans } from "../utils/i18n";
import {useFormState} from "../FormComponents/FormState";


const ProductFound = styled.div`
  display: flex;
  margin-top: 30px;
`;

const ProductFoundHeading = styled.h3`
    margin: 0;
`;

const ProductItem = styled.div`
    transition: background-color .2s,color .2s;
    //border: 2px solid ${props => props.theme.gray};
    border-radius: 5px;
`;

const MarginTop = styled.div`
  margin-top: 15px;
`

const ProductImage = styled.img`
    max-width: 100%;
    border-radius: 30px;
`

const ProblemSelect = React.memo(function ({ values, addCompany, addCoverageId, setAddressId }) {
    const orderEntryState = useFormState();
    const { product, requesttype, serialnumber, problem_1, problem_2, problem_description } = values;
    const selectedProduct = orderEntryState && orderEntryState.products && orderEntryState.products.find(item => String(item.id) === product);

    const currentProblem = selectedProduct && selectedProduct.problems && selectedProduct.problems.find(item => parseInt(values.problem_1) === item.id);

    if(!selectedProduct || !selectedProduct.problems) {
        return <div></div>
    }

    return (
        <div>
            <div>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={8}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <Field
                                    name={'problem_1'}
                                    type={'select'}
                                    component={Select}
                                    validate={value => (value ? undefined : <Trans i18nKey="serialNumber.required">Required</Trans>)}
                                    field={{
                                        label: <Trans i18nKey="serialNumber.problem">Problem</Trans>,
                                        titel: <Trans i18nKey="serialNumber.problem.title">123</Trans>,
                                        options: selectedProduct.problems.map(problem => ({
                                            value: problem.id,
                                            label: problem.name,
                                        })),
                                    }}
                                />
                                {
                                    currentProblem && currentProblem.problems.length > 0 &&
                                        <MarginTop>
                                            <Field
                                                name={'problem_2'}
                                                type={'select'}
                                                component={Select}
                                                validate={value => (value ? undefined : 'Erforderlich')}
                                                field={{
                                                    label: <Trans i18nKey="serialNumber.problem">Problem</Trans>,
                                                    titel: <Trans i18nKey="serialNumber.problem.title">123</Trans>,
                                                    options: currentProblem.problems.map(problem => ({
                                                        value: problem.id,
                                                        label: problem.name,
                                                    })),
                                                }}
                                            />
                                        </MarginTop>
                                }
                            </Grid>
                        </Grid>
                        {
                            currentProblem && (currentProblem.problems.length === 0 || values.problem_2) &&
                            <MarginTop>
                                <Field
                                    name={'problem_description'}
                                    type={'text'}
                                    component={TextInput}
                                    validate={value => (value ? undefined : <Trans i18nKey="serialNumber.required">Required</Trans>)}
                                    field={{
                                        label: <Trans i18nKey="serialNumber.problemDescription">Problem description</Trans>,
                                    }}
                                />
                            </MarginTop>
                        }
                    </Grid>
                </Grid>
            </div>
        </div>
    );
},
function areEqual(prevProps, nextProps) {
    return JSON.stringify(prevProps) === JSON.stringify(nextProps);
});

export default ProblemSelect;
